import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { cssClass } from '../../../style';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { DataRoleSubspaceProps } from '../../types/DataRoleSubspaceProps';
import { extractLuidFromFieldConceptUri } from '../../utils/ExtractLuidFromFieldConceptUri';
import { RadioEditProvider } from '../../utils/RadioEditProvider';
import { DefinitionSubspaceAboutSection } from './about-section/DefinitionSubspaceAboutSection';
import { DefinitionSubspaceValuesSection } from './values-section/DefinitionSubspaceValuesSection';

const cssPrefix = 'DataRoleDefinitionSubspace';

const containerClass = cssClass(cssPrefix, 'container', {
  boxSizing: 'border-box',
  marginLeft: TabStyles.Spacing.ExtraLargeSpace,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const DefinitionSubspace = (props: DataRoleSubspaceProps & { hasEditPermissions: boolean })  => {
  const isReadonly = !FeatureFlags.semanticsServiceDataRoleEditingEnabled || !props.hasEditPermissions;
  return <div className={containerClass} data-tb-test-id={'data-role-definition-space-' + props.dataRoleDetailInfo.id}>
    <RadioEditProvider isReadonly={isReadonly}>
      <DefinitionSubspaceAboutSection
        dataTypes={props.dataRoleDetailInfo.dataTypes}
        description={props.dataRoleDetailInfo.description || ''}
        synonyms={props.dataRoleDetailInfo.fieldSynonyms || []}
        siteUrls={props.siteUrls}
        luid={extractLuidFromFieldConceptUri(props.dataRoleDetailInfo.fieldConceptUri)}
      />
      <DefinitionSubspaceValuesSection
        valuesList={props.dataRoleDetailInfo.values}
        valueCount={props.dataRoleDetailInfo.valueCount}
      />
    </RadioEditProvider>
  </div>;
};
